import {
    Heading,
    Stack,
    Text,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import BookingRequestContinueButton from "components/booking-request/booking-request-continue-button";
import { SafeHTML } from "components/safe-html";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Routes } from "routes";

export function BookingRequestIntro() {
    const { t } = useTranslation();
    const { data: settings } = useExternalBookingSettings();
    const navigate = useNavigate();

    const handleContinue = () => {
        const path = location.pathname.replace(
            `/${Routes.BOOKING_REQUEST_INTRO}`,
            `/${Routes.BOOKING_REQUEST}`
        );
        void navigate({ pathname: path, search: location.search });
    };

    const footerHeight = "104px";
    return (
        <Stack
            spacing={ThemeSpaceVariable.Large}
            mb={{
                base: footerHeight,
            }}
        >
            {settings?.inquiryInfo && (
                <Stack px={ThemeSpaceVariable.Medium} spacing={ThemeSpaceVariable.Medium}>
                    <Heading as="h2" fontSize={ThemeFontSizeVariable.X2Large}>
                        {t("bookingRequest.title")}
                    </Heading>
                    <Text wordBreak="break-word" overflowWrap="anywhere">
                        <SafeHTML
                            element="span"
                            options={{
                                allowedTags: ["a", "br"],
                                allowedSchemes: ["tel", "mailto", "https"],
                            }}
                            html={settings?.inquiryInfo}
                        />
                    </Text>
                </Stack>
            )}
            <BookingRequestContinueButton handleContinue={handleContinue} />
        </Stack>
    );
}
